import React from "react";
import { Link } from "react-router-dom";
import { FiSmile, FiLoader, FiThumbsUp } from "react-icons/fi";

import Section from "../components/primatives/Section";
import SectionKey from "../components/primatives/SectionKey";
import ActionButton from "../components/primatives/ActionButton";
import Loader from "../components/primatives/Loader";
import SectionHeader from "../components/primatives/SectionHeader";
import ShowCredentials from "../components/ShowCredentials";
import ThankYouPurchase from "../components/ThankYouPurchase";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      putPairs: [],
      loadState: props.helpers.loadState(),
      thankYouPurchase: false
    };
  }

  async componentDidMount() {
    // check for refresh app.
    if (this.props.location.search === "?login=true") {
      // a login happened / refresh app, and redirect
      await this.props.helpers.refreshApp();
      // update loadedState.
      this.setState({ loadState: this.props.helpers.loadState() });
      this.props.history.push("/");
    }

    // check for purchase complete...
    if(this.props.location.search === "?purchase=true") {
      setTimeout(async () => {
        this.props.helpers.launchConfetti();
        await this.props.helpers.refreshApp();
      },1500);
      this.setState({thankYouPurchase: true});
      this.props.history.push("/");
    }

    // load key-pairs from put.
    const put = this.props.helpers.put();
    try {
      const putPairs = await put.all();
      this.setState({ putPairs });
    } catch (e) {
      console.log("could not load keypairs");
    }
    this.setState({ isLoading: false });
  }

  renderSections = () => {
    let { putPairs, isLoading } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    if (putPairs.length === 0) {
      return (
        <Section>
          <SectionHeader>
            <FiSmile /> Ready to add data?{" "}
          </SectionHeader>
          <div className="text-sm">
            Put is a key-value store. It's powered by a public blockchain which
            means:
            <br />
            <br />
            <ul className="list-disc">
              <li>
                You can access data: <i>with or without</i> us.
              </li>
              <li>Data cannot be censored or tampered with.</li>
              <li>
                Pay once; store forever; read forever. <FiThumbsUp />
              </li>
            </ul>
          </div>
        </Section>
      );
    }

    return putPairs.map((pp) => (
      <SectionKey theKey={pp.key} theVal={pp.value} key={pp.key} />
    ));
  };

  render() {
    const { loadState, putPairs, thankYouPurchase } = this.state;
    const { account, backup } = loadState;
    const { launchConfetti } = this.props.helpers;

    return (
      <div className="container mx-auto">

        {thankYouPurchase ? <ThankYouPurchase launchConfetti={launchConfetti} /> : null}

        {backup && !putPairs ? (
          <Section>
            <SectionHeader>
              <FiLoader />{" "}
              <span className="text-indigo-700 font-extrabold">
                Woohoo! You're in!
              </span>
            </SectionHeader>
            <div className="text-sm mb-5">
              Remember to save your credentials. You need them to update
              key-value pairs.
            </div>
            <ShowCredentials username={account.name} privateKey={account.key} />
          </Section>
        ) : null}

        {/* add new key-val pair link */}
        <Link to="/insert">
          <ActionButton>» Add new key-value pair.</ActionButton>
        </Link>
        <br />
        <br />

        {this.renderSections()}
      </div>
    );
  }
}

export default Home;
